import type { PageCompositing } from '@sosocio/creator-types/api';

export interface ResolvedPageCompositing {
	blendMode: 'multiply' | 'normal';
	opacity: number;
}

/**
 * Resolves supported preview blending without changing persisted artwork settings.
 *
 * @param compositing Optional page specification with independent opacity.
 * @returns Normalized settings, defaulting to opaque normal blending.
 */
export function resolvePageCompositing(compositing?: PageCompositing | null): ResolvedPageCompositing {
	return {
		blendMode: compositing?.blendMode === 'multiply' ? 'multiply' : 'normal',
		opacity: typeof compositing?.opacity === 'number' && Number.isFinite(compositing.opacity)
			? Math.min(
				1,
				Math.max(
					0,
					compositing.opacity,
				),
			)
			: 1,
	};
}
